<div class="energy-table-container">
  <table class="table table-hover">
    <thead>
      <th id="energy_id">ID</th>
      <th id="energy_desc">Description</th>
      <th id="energy_date">Date</th>
      <th id="energy_effort">Effort</th>
    </thead>
    <tbody>
      @for (energy of energyEntries; track energy.id) {
        <tr (click)="select(energy, content)">
          <td>{{energy.id}}</td>
          <td>{{energy.description}}</td>
          <td>{{energy.date}}</td>
          <td>{{energy.effort}}</td>
        </tr>
      }
    </tbody>
  </table>
</div>

<div>
  <button class="btn btn-success" (click)="selectNew(content)">Insert</button>
</div>

<div class="chart-section">
  @for (day of energyEntriesPerDay; track day) {
    <div class="chart-day">
      <div class="chart">
        <canvas height="200"
          baseChart
          [data]="day.chartData"
          [type]="pieChartType"
          [options]="pieChartOptions"
          [legend]="true">
        </canvas>
      </div>
      <div style="text-align: center">{{day.day}} ({{dayToWeekDay(day.day)}})</div>
    </div>
  }
</div>


<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Set Energy</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="description">Description</label>
        <input id="description" class="form-control" name="description" [(ngModel)]="currentEntry.description">
      </div>
      <div class="form-group">
        <label for="date">Date</label>
        <div class="input-group">
          <input id="date" class="form-control" placeholder="yyyy-mm-dd" name="dp" ngbDatepicker
            #dp="ngbDatepicker" [(ngModel)]="currentEntry.date">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="dp.toggle()" type="button"></button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="effort">Effort</label>
        <input id="effort" class="form-control" name="effort" type="number" [(ngModel)]="currentEntry.effort">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button>
  </div>
</ng-template>
